export default function count(iterable) {
    return [...iterable].length;
}
